import { type PropsWithChildren } from "react";
import { Box } from "@ui/components/layout/box/Box";

type MainWrapperProps = PropsWithChildren;

export function MainWrapper({ children, ...rest }: MainWrapperProps) {
    return (
        <Box as="main" minBlockSize="100vh" {...rest}>
            {children}
        </Box>
    );
}
